// extracted by mini-css-extract-plugin
export var card = "_q2-0";
export var content = "_q2-2";
export var details = "_q2-3";
export var icon = "_q2-1";
export var iconBlue = "_q2-5";
export var iconBrand = "_q2-4";
export var iconGrayBlue = "_q2-6";
export var iconGreen = "_q2-7";
export var iconIndigo = "_q2-8";
export var iconOrange = "_q2-9";
export var iconPurple = "_q2-a";
export var iconRed = "_q2-b";
export var iconWarning = "_q2-c";